import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.hidden)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([[_ctx.$style.visible, _ctx.selected ? _ctx.$style.selected : null], "mapbox-marker"]),
      ref: "marker",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      (_ctx.$slots.popup)
        ? _renderSlot(_ctx.$slots, "popup", { key: 0 })
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("img", {
          src: require('../../../img/map/marker.svg').default,
          width: "30"
        }, null, 8 /* PROPS */, _hoisted_1)
      ])
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}